const LiveGoodsType = {
    SELF: 'self',
    JD: 'jd',
    PDD: 'pdd'
}

export default LiveGoodsType;